var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theWorldBox",style:({width:_vm.nowClass == '模型'?'1600px':'1440px'})},[_c('div',[_vm._v("开发中，敬请期待")])])}
var staticRenderFns = []

export { render, staticRenderFns }